module.exports = __webpack_public_path__ + "static/media/MongoDB_Logo.25bd805f.svg";